export default "__VITE_ASSET__Cfoo2x_u__"